<template>
    <!-- div to calculate width -->
    <div class="invisible" ref="widthCalc"></div>

    <!-- todo: Add transitions -->
    <template v-if="width > 0 && (items && items.length)">
        <MasonryWall v-bind="$attrs" :items="items" :column-width="columnWidth" :gap="gap">
            <template #default="{item, index}">
                <slot :item="item" :index="index"></slot>
            </template>
        </MasonryWall>
    </template>
</template>

<script>
import MasonryWall from "@yeger/vue-masonry-wall";

export default {
    components: {MasonryWall},
    props: {
        items: Array,
        columns: Number,
        gap: Number
    },
    data() {
        return {
            width: 0
        };
    },
    computed: {
        columnWidth() {
            // If we are on a mobile view, we should only have 1 column
            if (this.width < 768) {
                return this.width - this.gap;
            }

            return this.width / this.columns - this.gap;
        }
    },
    mounted() {
        window.addEventListener("resize", this.getWidth);

        this.getWidth();
    },
    methods: {
        getWidth() {
            this.width = this.$refs.widthCalc.offsetWidth;
        },
    }
};
</script>

<style scoped>

</style>
